// extracted by mini-css-extract-plugin
export var articleLink = "Fb";
export var articleWrap = "Gb";
export var avatar = "Lb";
export var avatarImg = "Mb";
export var content = "Hb";
export var des = "Ib";
export var img = "Ob";
export var imgWrap = "Nb";
export var subtitle = "Kb";
export var title = "Jb";